import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { InputLabel } from 'shared/mui/Labels/InputLabel/InputLabel';

export const StyledBox = styled(Box)({
  display: 'flex',
  top: '50%',
  flexDirection: 'column',
  padding: 0,
});

export const StyledCardContent = styled(CardContent)({
  padding: '24px 24px 0 !important',
});

export const StyledInputLabel = styled(InputLabel)({
  background: '#fff',
  padding: '0 4px',
  left: '-4px',
});
